import { render, staticRenderFns } from "./appPcAd.vue?vue&type=template&id=086f9a65&scoped=true&"
import script from "./appPcAd.vue?vue&type=script&lang=js&"
export * from "./appPcAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f9a65",
  null
  
)

export default component.exports